(() => {
  function validIMEI(value) {
    if (!/^\d{15}$/.test(value) || /^(\d)\1+$/.test(value)) return false;
    return [...value].reduce((sum, character, index) => {
      const digit = Number(character) * (index % 2 ? 2 : 1);
      return sum + (digit > 9 ? digit - 9 : digit);
    }, 0) % 10 === 0;
  }
  window.EOTradeIdentifier = (root, input, button) => {
    const dialog = root.querySelector('[data-imei-dialog]');
    const error = root.querySelector('[data-identifier-error]');
    const copy = JSON.parse(root.querySelector('[data-identifier-copy]').textContent);
    let previousOverflow = '';
    const value = () => input.value.trim().replace(/\s+/g, '');
    const validate = (showError = false) => {
      const valid = validIMEI(value());
      button.disabled = !value();
      input.setAttribute('aria-invalid', String(showError && !valid));
      error.textContent = showError && !valid ? copy.imeiError : '';
      error.hidden = !error.textContent;
      return valid;
    };
    const clear = () => { input.value = ''; validate(); };
    const open = currentValue => {
      if (dialog.open) return;
      input.value = currentValue || '';
      validate();
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      input.focus({ preventScroll: true });
    };
    const close = () => { if (dialog.open) dialog.close(); };
    dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow; });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button:not(:disabled), input:not(:disabled)')].filter(control => control.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    root.querySelector('[data-close-imei]').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    input.addEventListener('input', () => validate());
    return { validate, value, clear, open, close };
  };
})();
